import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Alert, Link, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import styled from 'styled-components';

interface DropZoneProps {
    isDragActive: boolean;
}

export const DropZoneContainer = styled.div`
    padding: 0.5rem 1rem;
`;

export const StyledDropZone = styled.div<DropZoneProps>`
    min-height: 200px;

    background: ${(props) => (props.isDragActive ? props.theme.colors.secondary.hoverBackground : props.theme.colors.secondary.lightBackground)};

    border: 2px dashed #b0b0b0;
    box-sizing: border-box;
    border-radius: 10px;
`;

export const StyledCloudIconContainer = styled.div`
    text-align: center;
    padding-top: 30px;
`;

export const StyledCloudUploadIcon = withStyles(() => ({
    root: {
        height: '70px',
        width: '70px'
    }
}))(CloudUploadIcon);

export const StyledChooseFileContainer = styled.div`
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
`;

export const StyledAlert = styled(Alert)`
    .MuiAlert-message {
        width: 100%;
    }
`;

export const StyledMaxAlert = styled(StyledAlert)`
    display: flex;
    align-items: center;
`;

export const Errors = styled.div`
    background-color: ${(props) => props.theme.colors.backgroundError};
    max-height: 350px;
    width: 100%;
    overflow: scroll;
    padding: 0;
    border-radius: 3px;
`;

export const ErrorFooter = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const StyledLink = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const TemplateLinkContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
`;

export const TemplateLink = styled(Link)`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 auto;
    
`;

export const ErrorRow = styled.div`
    display: flex;
    margin-bottom: 0.2rem;

    &:last-child {
        margin-bottom: 0;
    }
`;
export const StyledErrorTypography = styled(Typography)`
    margin-right: 0.2rem;
`;
